import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Paper,
  Button,
} from "@mui/material";

const ManageFAQ = () => {
  const [faqs, setFaqs] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [limit, setLimit] = useState(5);

  // Fetch FAQs from the backend
  const fetchFAQs = async (page, limit) => {
    try {
      const response = await fetch(
        `http://localhost:5000/api/faq?page=${page}&limit=${limit}`
      );
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      setFaqs(data.data);
      setTotalPages(Math.ceil(data.meta.total / limit));
    } catch (error) {
      console.error("Error fetching FAQs:", error);
    }
  };

  // Handle page change
  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage + 1);
  };

  // Handle rows per page change
  const handleRowsPerPageChange = (event) => {
    setLimit(parseInt(event.target.value, 10));
  };

  // Fetch FAQs on component load and whenever page or limit changes
  useEffect(() => {
    fetchFAQs(currentPage, limit);
  }, [currentPage, limit]);

  const handleButtonClick = (action) => {
    alert(`${action} button clicked!`);
  };

  return (
    <div>
      <h1>Manage FAQs</h1>
      <div>
        {/* Table for displaying FAQs */}
        <div>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="FAQ table">
              <TableHead>
                <TableRow>
                  <TableCell align="center">FAQ ID</TableCell>
                  <TableCell align="left">Question</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {faqs.length > 0 ? (
                  faqs.map((faq) => (
                    <TableRow key={faq.faq_id}>
                      <TableCell align="center">{faq.faq_id}</TableCell>
                      <TableCell>{faq.question}</TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={2} align="center">
                      No FAQs available.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          {/* Pagination */}
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={totalPages * limit}
            rowsPerPage={limit}
            page={currentPage - 1}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleRowsPerPageChange}
          />
        </div>

        {/* Buttons */}
        <div>
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleButtonClick("Add FAQ")}
          >
            Add FAQ
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleButtonClick("View FAQs")}
          >
            View FAQs
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleButtonClick("Update FAQ")}
          >
            Update FAQ
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleButtonClick("Delete FAQ")}
          >
            Delete FAQ
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ManageFAQ;
